import React from 'react';
import { Link } from 'react-router-dom';

function App() {
  return (
    <div style={{ textAlign: 'center', marginTop: '4rem' }}>
      <h1>ForgePass is Ready</h1>
      <p>This is your clean React app to start building your dApp frontend.</p>
      <Link to="/home" style={{ marginTop: '1rem', display: 'inline-block', textDecoration: 'none', color: '#fff', background: '#4f46e5', padding: '10px 20px', borderRadius: '8px' }}>
        Go to Login Page
      </Link>
    </div>
  );
}

export default App;


